(() => {
  const strings = window.chepaStrings?.collection || {};
  function setup(section) {
    const tools = section.querySelector('[data-chepa-collection-tools]');
    if (!tools || tools.dataset.ready) return;
    tools.dataset.ready = 'true';
    tools.hidden = false;
    const form = tools.querySelector('form');
    const input = form.querySelector('input');
    const clear = tools.querySelector('[data-chepa-search-clear]');
    const status = tools.querySelector('[role="status"]');
    let request;
    let version = 0;
    let busy = false;
    let debounce;
    let page = Number(section.querySelector('[data-chepa-pagination]')?.dataset.page || 1);
    let firstLoadedPage = page;
    const grid = () => section.querySelector('[data-chepa-product-grid]');
    const cards = () => Array.from(grid()?.children || []).filter(el => el.matches('.product-block'));
    const pagination = () => section.querySelector('[data-chepa-pagination]');
    const more = () => section.querySelector('[data-chepa-load-more]');
    const query = () => input.value.trim().toLocaleLowerCase();
    function cancel() {
      ++version;
      request?.abort();
      busy = false;
      clearTimeout(debounce);
    }
    function enhance() {
      const native = pagination()?.querySelector('.pagination');
      if (native) native.hidden = true;
      if (more()) { more().hidden = Boolean(query()); more().disabled = busy; }
    }
    function apply() {
      const terms = query().split(/\s+/).filter(Boolean);
      let count = 0;
      cards().forEach(card => {
        const title = card.querySelector('.product-block__title')?.textContent.toLocaleLowerCase() || '';
        card.hidden = !terms.every(term => title.includes(term));
        if (!card.hidden) ++count;
      });
      clear.hidden = !terms.length;
      if (terms.length) {
        status.textContent = busy ? strings.searching : (count ? strings.matches.replace('[count]', count) : strings.no_matches);
      } else {
        status.textContent = busy ? strings.loading : strings.showing.replace('[count]', cards().length);
      }
      enhance();
    }
    function initImages() {
      if (window.theme?.ProductBlockManager && window.jQuery) {
        window.theme.ProductBlockManager.loadImages(window.jQuery(section));
      }
    }
    async function fetchPage(href, activeVersion, replace = false) {
      const url = new URL(href, location.href);
      if (url.origin !== location.origin) throw new Error('Invalid collection URL');
      url.searchParams.set('section_id', section.dataset.sectionId);
      const response = await fetch(url, {signal:request.signal});
      if (!response.ok) throw new Error('Unable to load collection');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (activeVersion !== version) return [];
      const incoming = doc.querySelector('[data-chepa-product-grid]');
      const incomingPagination = doc.querySelector('[data-chepa-pagination]');
      if (!incoming || !incomingPagination || !grid()) throw new Error('Incomplete collection response');
      if (!replace && Number(incomingPagination.dataset.page) <= page) throw new Error('Collection pagination did not advance');
      const existing = new Set(replace ? [] : cards().map(el => el.dataset.productId));
      const additions = Array.from(incoming.children).filter(el => el.matches('.product-block') && !existing.has(el.dataset.productId));
      if (replace) grid().replaceChildren();
      grid().append(...additions);
      pagination().innerHTML = incomingPagination.innerHTML;
      page = Number(incomingPagination.dataset.page);
      pagination().dataset.page = String(page);
      pagination().dataset.total = incomingPagination.dataset.total;
      return additions;
    }
    function showError() {
      status.textContent = strings.error;
      const native = pagination()?.querySelector('.pagination');
      if (native) native.hidden = false;
      if (more()) { more().hidden = false; more().disabled = false; }
    }
    async function search() {
      cancel();
      const activeVersion = version;
      if (!query()) { apply(); initImages(); return; }
      request = new AbortController();
      busy = true;
      apply();
      try {
        if (firstLoadedPage > 1) {
          const start = new URL(location.href);
          start.searchParams.delete('page');
          await fetchPage(start, activeVersion, true);
          firstLoadedPage = 1;
        }
        while (activeVersion === version && more()) {
          await fetchPage(more().dataset.nextUrl, activeVersion);
          apply();
        }
        if (activeVersion !== version) return;
        busy = false;
        apply();
        initImages();
      } catch (error) {
        if (activeVersion !== version || error.name === 'AbortError') return;
        busy = false;
        initImages();
        showError();
      }
    }
    form.addEventListener('submit', event => { event.preventDefault(); search(); });
    input.addEventListener('input', () => { clearTimeout(debounce); debounce = setTimeout(search, 350); });
    clear.addEventListener('click', () => { input.value = ''; search(); input.focus(); });
    section.addEventListener('click', async event => {
      const button = event.target.closest('[data-chepa-load-more]');
      if (!button || busy) return;
      if (query()) { search(); return; }
      cancel();
      const activeVersion = version;
      request = new AbortController();
      busy = true;
      apply();
      try {
        const additions = await fetchPage(button.dataset.nextUrl, activeVersion);
        if (activeVersion !== version) return;
        busy = false;
        apply();
        initImages();
        const firstLink = additions[0]?.querySelector('.product-block__title')?.closest('a');
        firstLink?.focus({preventScroll:true});
      } catch (error) {
        if (activeVersion !== version || error.name === 'AbortError') return;
        busy = false;
        showError();
      }
    });
    section.addEventListener('chepa:collection:loading', () => { cancel(); input.disabled = true; form.querySelector('[type="submit"]').disabled = true; });
    section.addEventListener('chepa:collection:updated', () => {
      page = Number(new URL(location.href).searchParams.get('page') || 1);
      firstLoadedPage = page;
      input.disabled = false;
      form.querySelector('[type="submit"]').disabled = false;
      if (query()) search(); else apply();
    });
    apply();
  }
  document.querySelectorAll('[data-section-type="collection-template"]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-section-type="collection-template"]').forEach(setup));
})();
